import styled from '@emotion/styled'
import { getPasswordRequirements } from '@open-tender/utils'

const PasswordRequirementsView = styled.div`
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: ${(props) => props.theme.border.radius};
  border: 1px solid ${(props) => props.theme.border.color};
`

const PasswordRequirementsTitle = styled.p`
  margin: 0 0 0.5rem;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  font-weight: ${(props) => props.theme.fonts.weights?.semiBold || '600'};
  color: ${(props) => props.theme.fonts.headings.color};
`

const PasswordRequirementsList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

const PasswordRequirementItem = styled.li<{ met: boolean }>`
  display: flex;
  align-items: center;
  margin: 0.25rem 0;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  color: ${(props) =>
    props.met ? props.theme.colors.success : props.theme.fonts.body.color};

  &:before {
    content: '${(props) => (props.met ? '✓' : '✗')}';
    display: inline-block;
    width: 1.5rem;
    margin-right: 0.5rem;
    font-weight: ${(props) => props.theme.fonts.weights?.bold || '700'};
    color: ${(props) =>
      props.met ? props.theme.colors.success : props.theme.colors.alert};
  }
`

interface PasswordRequirementsProps {
  password: string
  showTitle?: boolean
}

const PasswordRequirements = ({
  password,
  showTitle = true,
}: PasswordRequirementsProps) => {
  const requirements = getPasswordRequirements(password)

  return (
    <PasswordRequirementsView>
      {showTitle && (
        <PasswordRequirementsTitle>
          Password must include:
        </PasswordRequirementsTitle>
      )}
      <PasswordRequirementsList>
        {requirements.map((req, index) => (
          <PasswordRequirementItem key={index} met={req.met}>
            {req.message}
          </PasswordRequirementItem>
        ))}
      </PasswordRequirementsList>
    </PasswordRequirementsView>
  )
}

export default PasswordRequirements
